import ApiService from "./api.service";
// import ApiMockService from './api.mock.service'

/**
 * * Habits
 *
 * getBadHabits --> Get List bad Habits.
 *
 */
const HabitService = {
  getBadHabits: async function (params = {}, lang) {
    const response = await ApiService._get("api/habit/bad-habit", params, lang);
    return response.data;
  },
};

export default HabitService;
